import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Custom__qgiv-clock",
  "use": "Custom__qgiv-clock-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 13 13\" id=\"Custom__qgiv-clock\"><path fill=\"#545455\" d=\"M6.5 0a.812.812 0 0 0-.813.813v1.625a.812.812 0 1 0 1.625 0v-.744a4.875 4.875 0 1 1-4.224 1.325.814.814 0 0 0-1.137-1.163A6.5 6.5 0 1 0 13 6.5 6.5 6.5 0 0 0 6.499 0ZM4.9 4.038a.61.61 0 0 0-.86.86L6.07 6.93a.61.61 0 0 0 .86-.86l-2.03-2.032Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol